import type { ReactNode } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons"
import { Stack, Tooltip, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    row: {
        borderRadius: ".75rem",
        padding: ".75rem",
        background: theme.palette.tailwind.blue[50],

        "& label.MuiFormControlLabel-root": {
            margin: 0,
            justifyContent: "flex-start",
        },
        "& .MuiFormControl-root": {
            width: "auto",
            flex: "none",
        },
    },
    icon: {
        color: theme.palette.tailwind.gray[500],
    },
}))

type SwitchFieldRowProps = Readonly<{
    label?: string
    description?: string
    /** The control itself — a `FormikSwitch` for config-driven fields, a plain `Switch` otherwise. */
    children: ReactNode
}>

/**
 * The blue labelled row used for every boolean setting in the booking dialog
 * ("External meeting", "Private meeting", "Add participants from Outlook").
 */
export function SwitchFieldRow({ label, description, children }: SwitchFieldRowProps) {
    const { classes } = useStyles()

    return (
        <Stack flexDirection="row" gap=".5rem" justifyContent="space-between" className={classes.row}>
            <Stack flexDirection="row" alignItems="center" gap=".5rem">
                <Typography variant="subtitle1">{label}</Typography>
                {description && (
                    <Tooltip title={description} arrow>
                        <FontAwesomeIcon icon={faCircleInfo} className={classes.icon} />
                    </Tooltip>
                )}
            </Stack>

            {children}
        </Stack>
    )
}
